import axios from 'axios'
import { config, url } from '../../index'
import usersApi from '@/api/usersApi'

const state = () => ({
  headUserId: null,
  subDepartments: [],
  transferModal: {
    active: false,
    profileId: null,
    title: 'Перевод',
    isTransferred: false,
    comment: '',
    history: [
      { date: '04.12.2020, 10:30', comment: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip', from: 'Название отдела', to: 'Название отдела' },
      { date: '04.12.2020, 10:30', comment: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip', from: 'Название отдела', to: 'Название отдела' }
    ],
    valid: {}
  },
  isLoading: true
})

const getters = {
  subordinatesListDepartments: state => state.subDepartments,
  subordinatesListTransferModal: state => state.transferModal,
  subordinatesListPageIsLoading: state => state.isLoading
}

const mutations = {
  SET_USER_SUB_DEPARTMENTS: (state, subDepartments) => {
    state.subDepartments = subDepartments
    state.isLoading = false
  },
  SET_HEAD_SUBORDINATES_ID: (state, userId) => {
    state.headUserId = userId
  },
  SHOW_SUBORDINATE_TRANSFER_MODAL: (state, userId) => {
    const modal = state.transferModal
    let user = null
    state.subDepartments.forEach(department => {
      const foundUser = department.users.find(user => user.id === userId)
      if (foundUser) {
        user = foundUser
      }
    })

    modal.active = true
    modal.profileId = user.profile.id
    modal.isTransferred = user.profile.is_transferred
    modal.comment = user.profile.transfer_comment
  },
  TOGGLE_SUBORDINATE_TRANSFER_COMMENT: (state) => {
    state.transferModal.isTransferred = !state.transferModal.isTransferred
  },
  SET_SUBORDINATE_TRANSFER_COMMENT: (state, comment) => {
    state.transferModal.comment = comment
  },
  CLOSE_SUBORDINATE_TRANSFER_MODAL: (state) => {
    const modal = state.transferModal
    modal.active = false
    modal.profileId = null
    modal.isTransferred = false
    modal.comment = ''
    /* modal.history = [] */
  },
  // reset store
  RESET_USER_SUBORDINATES_LIST_STORE: (state) => {
    state.searchValue = ''
  }
}

const actions = {
  getUserSubordinates ({ commit }, userId) {
    usersApi.getSingle(userId).then(response => {
      const user = response.data.data
      const subDepartmentIds = user.sub_departments ? user.sub_departments.map(item => item.id) : null
      const subDepartments = []

      async function getExtendedUserInfo () {
        if (subDepartmentIds) {
          for (const id of subDepartmentIds) {
            await axios.get(`${url}/departments/${id}?expand=users`, config).then(response => {
              const extendedSubDepartment = {
                ...response.data.data,
                users: []
              }
              const userIds = response.data.data.users ? response.data.data.users.map(user => user.id) : []

              for (const id of userIds) {
                usersApi.getSingle(id).then(response => {
                  extendedSubDepartment.users.push(response.data.data)
                }).catch(error => {
                  console.log('ошибка получения сотрудников с профилями для подотдела', error.response)
                })
              }

              subDepartments.push(extendedSubDepartment)
            })
          }
        }
      }

      getExtendedUserInfo().then(() => {
        commit('SET_USER_SUB_DEPARTMENTS', subDepartments)
        commit('SET_HEAD_SUBORDINATES_ID', userId)
      })
    }).catch(error => {
      console.log('ошибка запроса пользователя (Мои сотрудники)', error.response)
    })
  },
  updateUserSubordinateStatus ({ commit, state }, data) {
    const headUserId = state.headUserId
    const params = {
      id: data.userId,
      updateData: {
        // роли обязательное поле при редактировании сотрудника
        roles: data.roles.map(role => role.id),
        status_id: data.statusId
      }
    }

    usersApi.putUser(params).then(() => {
      this.dispatch('getUserSubordinates', headUserId)
    }).catch(error => {
      console.log('Ошибка обновления статуса подчиненного', error.response)
    })
  },
  showSubordinateTransferModal ({ commit }, userId) {
    commit('SHOW_SUBORDINATE_TRANSFER_MODAL', userId)
  },
  toggleUserSubordinateTransferStatus ({ commit }) {
    commit('TOGGLE_SUBORDINATE_TRANSFER_COMMENT')
  },
  setUserSubordinateTransferComment ({ commit }, data) {
    commit('SET_SUBORDINATE_TRANSFER_COMMENT', data)
  },
  updateUserSubordinateTransferInfo ({ commit, state }) {
    const headUserId = state.headUserId
    const profileId = state.transferModal.profileId
    const comment = state.transferModal.comment
    const transferStatus = state.transferModal.isTransferred
    const profileData = {
      transfer_comment: comment,
      is_transferred: transferStatus
    }

    axios.put(`${url}/profiles/${profileId}`, profileData, config).then(response => {
      this.dispatch('getUserSubordinates', headUserId)
      commit('CLOSE_SUBORDINATE_TRANSFER_MODAL')
    }).catch(error => {
      console.log('Ошибка обновления инфы к переводу подчиненного', error.response)
    })
  },
  closeSubordinateTransferModal ({ commit }) {
    commit('CLOSE_SUBORDINATE_TRANSFER_MODAL')
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
